<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const snippet = `
    <hr class="divider my-7" />
  `;
</script>

<template>
  <section id="divider" class="page-section bg-sunsetPink40">
    <div class="container">
      <h2 class="heading heading-2 my-6">Divider</h2>
      <div class="m-auto mb-4 md:w-1/2 ">
        <p class="copy">
          Phasellus at aliquet mi. Nulla venenatis elementum congue. Ut tincidunt orci nisl, ut convallis nibh egestas quis. Orci varius natoque penatibus et magnis dis parturient montes, nascetur
          ridiculus mus.
        </p>
        {@html snippet}
        <p class="copy">
          Phasellus vitae mi ac velit semper pharetra. Nullam facilisis ac diam nec vulputate. Praesent ornare id ex porttitor luctus. Mauris at metus tortor. Nulla a purus ac risus gravida congue
          porta bibendum ante.
        </p>
      </div>
      <CodeSnippet id="divider" {snippet} />
    </div>
  </section>
</template>
